export default "__VITE_ASSET__CA8BIvvE__"